import classNames from 'classnames';
import React, { InputHTMLAttributes } from 'react';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string | React.ReactNode | Element;
  name: string;
  error?: string;
  theme?: 'primary' | 'secondary';
  checkboxPosition?: 'left' | 'right';
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      className,
      label,
      name,
      error,
      theme = 'primary',
      checkboxPosition = 'left',
      ...rest
    },
    ref,
  ) => {
    return (
      <div className={className}>
        <div
          className="flex items-center"
          data-checkbox-position={checkboxPosition}
        >
          <input
            id={name}
            name={name}
            type="checkbox"
            ref={ref}
            className="checkbox"
            {...rest}
          />

          <label
            htmlFor={name}
            className={classNames(
              'text-body text-sm',
              {
                primary: theme === 'primary',
                secondary: theme === 'secondary',
              },
              {
                'flex-row-reverse': checkboxPosition === 'right',
              },
            )}
          >
            {label}
          </label>
        </div>

        {error && (
          <p className="my-2 text-xs ltr:text-right rtl:text-left text-red-500">
            {error}
          </p>
        )}
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
